SJ.ImageLoader = {};

SJ.imagesLoaded = 0;

SJ.ImageLoader.imagesToLoad = [];
// SJ.ImageLoader.imagesToLoad = 0;

// SJ.ImageLoader.isLoaded = () => {
//   SJ.LoadingScreen.remainingToLoad--;
// }

SJ.ImageLoader.remainingToLoad = 0;
SJ.ImageLoader.totalToLoad = 0;

SJ.ImageLoader.imageAddedToLoadingQueue = () => {
  SJ.ImageLoader.remainingToLoad++;
  SJ.ImageLoader.totalToLoad++;

  SJ.LoadingScreen.imagesToLoad++;
  SJ.LoadingScreen.remainingToLoad++;

}

SJ.ImageLoader.imageLoaded = () => {
  SJ.ImageLoader.remainingToLoad--;

  SJ.LoadingScreen.remainingToLoad--;

  if(SJ.ImageLoader.remainingToLoad <= 0)
    SJ.ImageLoader.totalToLoad = 0;
}

SJ.ImageLoader.load = (imageName, callback) => {

  // try{
    SJ.ImageLoader.imageAddedToLoadingQueue();

    const image = SJ.ImageLoader.loadFromPath('skijump-js/sj-graphics/' + imageName, () => {
      SJ.ImageLoader.imageLoaded();

      if(callback)
        callback(image);
    });

    return image;
  // }catch(error){
  //   console.log(error);
  // }

}

SJ.ImageLoader.loadArray = (imageNamesArray, callback) => {
  const images = new Array(imageNamesArray.length);

  let loaded = 0;
  for(let i=0; i<images.length; i++) {
    images[i] = SJ.ImageLoader.load(imageNamesArray[i], () => {
      if(++loaded >= images.length) {
        callback(images);
      }
    })
  }

  return images;
}

SJ.ImageLoader.loadFromPath = (path, callback) => {
  if (path.includes('/mountainSS.png')) console.log(`%c @@@ ${path}`, 'color: red');
  if (path.includes('/Zakopane/')) SJ.imagesLoaded++;

  return loadImage(path, callback, () => console.log('LOADING IMAGE ERROR, path: ' + path));
}

SJ.ImageLoader.divideSpriteSheet = (ss, frameW, frameH, offsetX=0, offsetY=0) => {
  const frames = [];

  for(let y=offsetY; y<ss.height; y+=frameH) {
    for(let x=offsetX; x<ss.width; x+=frameW) {
      if(x + frameW <= ss.width && y + frameH <= ss.height) {
        frames.push(
          SJ.ImageLoader.getSubImage(ss, x, y, frameW, frameH)
        );
      }
    }
  }

  return frames;
}

SJ.ImageLoader.getSubImage = (image, sx, sy, w, h) => {
  const subImg = createImage(w, h);
  subImg.loadPixels();

  image.loadPixels();

  let i=0;
  for(let y=sy; y<sy+h; y++) {
    for(let x=sx; x<sx+w; x++) {
      let index = (x + y * image.width) * 4;
      for(let j=0; j<4; j++) {
        subImg.pixels[i++] = image.pixels[index++];
      }
    }
  }

  subImg.updatePixels();

  return subImg;
}